import { render, staticRenderFns } from "./ConfirmCustomer.vue?vue&type=template&id=3216912c&scoped=true"
import script from "./ConfirmCustomer.vue?vue&type=script&lang=js"
export * from "./ConfirmCustomer.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCustomer.vue?vue&type=style&index=0&id=3216912c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3216912c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VLayout,VSpacer})
